import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import get from 'lodash/get';
import { isOpen } from '../store/modal/selectors';
import { modalHide } from '../store/modal/actions';
import E2Preview from '../components/molecules/E2Preview';

const E2PreviewContainer = props => <E2Preview {...props} />;

E2PreviewContainer.propTypes = {
  hideModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  creative: get(state, 'updateCreative'),
  visible: isOpen(state.modal, 'e2-preview'),
});

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(modalHide('e2-preview')),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(E2PreviewContainer);
